import { Card } from "react-bootstrap";
import { BadgeDomain } from "../../../../_components/Abstractions/BadgeDomain";

export const ContractorServicesCard = ({ services, servicesSuffix }) => {
  if (!services || services?.length === 0) {
    return;
  }

  return (
    <>
      <Card border="light">
        <Card.Header as="h5">Usługi {servicesSuffix}</Card.Header>
        <Card.Body>
          {services.map(x => <BadgeDomain key={x.serviceId} bg={!x.isDeleted ? "info" : "danger"} size="smaller">{x.name}</BadgeDomain>)}
        </Card.Body>
      </Card>
    </>
  );
};